import { useSearchParams } from "react-router";

export function usePagination({pageSize}:{pageSize: number}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = Number(searchParams.get("page")) ?? 0;

    const handlePageChange = (newPage: number) => {
        setSearchParams(
            prev => {
                const next = new URLSearchParams(prev);
                next.set("page", newPage.toString());
                return next;
            },
            { replace: true },
        );
    };

    return {
        page,
        pageSize,
        onPageChange: handlePageChange,
    };
}
